<template>
    <div v-if="visible">
        <el-dialog title="查看模板" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="950px">    
            
            <el-tabs v-model="activeName" style="margin-top:15px;" type="border-card" @tab-click="handleClick">
                <el-tab-pane label="课程表" name="first">
                    <child1></child1>
                </el-tab-pane>

                <el-tab-pane v-for="(item, index) in data" :key="index" :label="item.tabTitle"  :name="item.tabTitle">
                    <child2 v-if="activeName == item.tabTitle" ></child2>    
                </el-tab-pane>

            </el-tabs>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="visible=false">关闭</el-button>
            </span>     -->
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import course from './gkxq/Course.vue'; // 课程表
    import occupation from './gkxq/Occupation.vue'; 
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        components:{
            child1:course,
            child2:occupation,
        },
        data(){
            return{
                visible: false,
                form:{
                    deptId:"",
                    teacherTemplateManageId:"",
                },
                //默认第一个选项卡
                activeName: "first",
                data:[]
            }
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.deptId=data.deptId;
                this.form.teacherTemplateManageId=data.id;
                sessionStorage.setItem("selectDeptId",this.form.deptId);
                sessionStorage.setItem("selectId",data.id);
                // 初始tabl
                this.getTabName();
                // 初始位置
                this.activeName="first";
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            handleClick(tab) {
                this.activeName=tab.name;
                sessionStorage.setItem("selectTabTitle",this.activeName);
            },
            // 获取tab名称
            getTabName(){
                let url  = this.teacherTemplateAssessIndexTabNameListUrl;
                let data = {
                    deptId:this.form.deptId,
                    teacherTemplateManageId:this.form.teacherTemplateManageId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data=res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/teacherAssess/template/GKXQMain.vue